export const ALTO = '#DEDEDE';
export const BLACK = '#000000';
export const GRAY = 'rgba(0, 0, 0, 0.54)';
export const MINE_SHAFT = '#3E3E3E';
export const SILVER = '#BEBEBE';
export const SILVER_CHALICE = '#9E9E9E';
export const WHITE = '#FFFFFF';
